<template>
  <div
    class="default-container"
    :style="{overflow: locked ? 'hidden' : 'auto'}"
  >
    <MainHeader
      v-if="
        !['signup-callback', 'signup-cpa-callback', 'signup-callback'].includes(
          $route.name,
        )
      "
      :mobile="mobile"
      :show-create-company="showCreateCompany"
      :show-confirm-delete-bank="showConfirmDeleteBank"
      :show-confirm-delete-company="showConfirmDeleteCompany"
      :show-confirm-delete-integration="showConfirmDeleteIntegration"
      @show-add-bank-popup="$emit('showAddBankPopup')"
    />
    <slot />
  </div>
</template>

<script>
import {datesMixin} from '@/mixins/datesMixin';
import MainHeader from '@/components/widgets/MainHeader.vue';
import {mapState} from 'vuex';

export default {
  name: 'DefaultLayout',
  components: {
    MainHeader,
  },
  mixins: [datesMixin],
  props: {
    mobile: {
      type: Boolean,
      default: () => false,
    },
    showCreateCompany: {
      type: Function,
      default: () => true,
    },
    showConfirmDeleteBank: {
      type: Function,
      default: () => false,
    },
    showConfirmDeleteCompany: {
      type: Function,
      default: () => false,
    },
    showConfirmDeleteIntegration: {
      type: Function,
      default: () => false,
    },
  },
  emits: ['showAddBankPopup'],
  computed: {
    ...mapState('app', ['locked']),
  },
};
</script>

<style lang="scss" scoped>
.default-container {
  //force high level container to take the total height of app
  min-height: 100%;
  height: 100%;
  border: var(--px3);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
